import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/models/user.model';

export interface UsersPreviewResult {
  /** Nombre de pila de cada asistente (campo `name`), separados por coma. */
  line: string;
  extraCount: number | null;
}

@Pipe({ name: 'usersPreview' })
export class UsersPreviewPipe implements PipeTransform {
  private displayNameForUser(user: User): string {
    return (user.name ?? '').trim();
  }

  transform(users: User[] | null | undefined, visibleCount: number): UsersPreviewResult {
    if (!users?.length) {
      return { line: '', extraCount: null };
    }

    const limit = visibleCount > 0 ? Math.min(visibleCount, users.length) : users.length;
    const slice = users.slice(0, limit);
    const labels = slice.map(user => this.displayNameForUser(user));
    const line = labels.filter(label => label.length > 0).join(', ');
    const overflow = users.length - slice.length;

    if (overflow > 0) {
      return { line, extraCount: overflow };
    }

    return { line, extraCount: null };
  }
}
